import { useMutation, useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { GET_ALL_EMPLOYEES } from '../../../../graphql/Catalog/Employees/employees'
import LayoutTable from '../../../Global/LayoutTable'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import ContentHeader from '../../../Layout/ContentHeader'
import moment from 'moment'
import { GET_ALL_JOB_POSITIONS } from '../../../../graphql/Catalog/JobPositions/jobPositions'
import { GET_ALL_SCHEDULE_GROUPS } from '../../../../graphql/Catalog/Employees/Groups/scheduleGroups'
import { REGISTER_LOG_EMPLOYEE } from '../../../../graphql/Catalog/Employees/Logs/employeeLogs'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'

const Employees = () => {
  const { showLoading, hideLoading } = useLoading()
  const [dataLayout, setDataLayout] = useState({
    dataTable: [],
    count: 0,
  })
  const [pagePagination, setPagePagination] = useState({
    searchQuery: '',
    limit: 10,
    offset: 0,
    filters: {
      job_position_id: null,
      schedule_group_id: null,
      start_date: null,
      end_date: null,
    },
  })
  const [options, setOptions] = useState({
    jobPositions: [],
    scheduleGroups: [],
  })

  const { loading, error, data, refetch } = useQuery(GET_ALL_EMPLOYEES, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      filters: {
        job_position_id: pagePagination.filters.job_position_id,
        schedule_group_id: pagePagination.filters.schedule_group_id,
        start_date: pagePagination.filters.start_date,
        end_date: pagePagination.filters.end_date,
      },
    },
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingJobPositions,
    error: errorJobPositions,
    data: dataJobPositions,
  } = useQuery(GET_ALL_JOB_POSITIONS, {
    variables: {},
    fetchPolicy: 'cache-and-network',
  })

  const {
    loading: loadingSchedule,
    error: errorSchedule,
    data: dataSchedule,
  } = useQuery(GET_ALL_SCHEDULE_GROUPS, {
    variables: {},
    fetchPolicy: 'cache-and-network',
  })

  const [registerActivity] = useMutation(REGISTER_LOG_EMPLOYEE)

  useEffect(() => {
    try {
      if (loading) return
      if (error) throw new Error(error.message)
      const { getAllEmployees } = data
      if (!getAllEmployees) throw new Error('No se encontraron empleados')
      const { count, rows } = getAllEmployees

      const dataTable = rows.map((employee) => {
        return {
          id: employee.id,
          nombre: `${employee.first_name} ${employee.last_name}`,
          email: employee.email,
          telefono: employee.phone,
          turno: employee.EmployeeToScheduleGroup
            ? employee.EmployeeToScheduleGroup.name
            : 'No asignado',
          puesto: employee.EmployeeToJobPosition
            ? employee.EmployeeToJobPosition.name
            : 'No asignado',
          registrar: (
            <>
              {(employee.EmployeeToLogsEmployee.length === 0 ||
                employee.EmployeeToLogsEmployee.length === 1) && (
                <span
                  className="btn btn-orange btn-sm"
                  onClick={() => handleRegisterActivity(employee.id)}
                >
                  {employee.EmployeeToLogsEmployee.length === 0
                    ? 'Marcar Entrada'
                    : employee.EmployeeToLogsEmployee.length === 1
                    ? 'Marcar Salida'
                    : ''}
                </span>
              )}
            </>
          ),
        }
      })

      setDataLayout({
        dataTable,
        count,
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loading, error, data])

  useEffect(() => {
    try {
      if (loadingJobPositions) return
      if (errorJobPositions) throw new Error(errorJobPositions.message)
      const { getAllJobPositions } = dataJobPositions
      if (!getAllJobPositions)
        throw new Error('No se encontraron puestos de trabajo')
      const { rows } = getAllJobPositions

      const jobPositions = rows.map((jobPosition) => {
        return {
          value: jobPosition.id,
          label: jobPosition.name,
        }
      })

      setOptions((prev) => ({
        ...prev,
        jobPositions,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingJobPositions, errorJobPositions, dataJobPositions])

  useEffect(() => {
    try {
      if (loadingSchedule) return
      if (errorSchedule) throw new Error(errorSchedule.message)
      const { getAllScheduleGroupsEmployees } = dataSchedule

      if (!getAllScheduleGroupsEmployees)
        throw new Error('No se encontraron grupos de horarios')
      const { rows } = getAllScheduleGroupsEmployees

      const scheduleGroups = rows.map((scheduleGroup) => {
        return {
          value: scheduleGroup.id,
          label: scheduleGroup.name,
        }
      })
      setOptions((prev) => ({
        ...prev,
        scheduleGroups,
      }))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingSchedule, errorSchedule, dataSchedule])

  const handleFiltersDateRange = (e, field) => {
    const newField = field === 'from' ? 'start_date' : 'end_date'
    setPagePagination((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [newField]:
          newField === 'start_date'
            ? moment(e.target.value)
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss')
            : moment(e.target.value).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      },
    }))
  }

  const handleFilters = (e, field) => {
    console.log('field', field, 'e', e)
    setPagePagination((prev) => ({
      ...prev,
      filters: {
        ...prev.filters,
        [field]: e ? e.value : null,
      },
    }))
  }

  const handleRegisterActivity = async (employeeId) => {
    showLoading()
    try {
      const { data: registerData } = await registerActivity({
        variables: {
          activiteEmployeeLogId: employeeId,
        },
        fetchPolicy: 'no-cache',
      })

      if (registerData.ActiviteEmployeeLog) {
        const { ActiviteEmployeeLog } = registerData
        if (!ActiviteEmployeeLog.status) {
          await refetch()
          return toastSweetAlert({
            mode: ActiviteEmployeeLog.mode,
            message: ActiviteEmployeeLog.message,
          })
        }

        await refetch()
        return toastSweetAlert({
          mode: ActiviteEmployeeLog.mode,
          message: ActiviteEmployeeLog.message,
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader title="" breadcrumb="" windowTitle="Empleados" />
      <LayoutTable
        title={'Empleados'}
        hideId
        data={dataLayout.dataTable}
        totalCount={dataLayout.count}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        cols_search="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
        cols_search_div="col-12"
        cols_filters="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-3 mt-3"
        cols_filters_div="col-12"
        FilterBarPlaceholder="Buscar empleado por nombre, email o teléfono"
        isFilterRangeShow
        filterRangeProps={{
          from: {
            value: pagePagination.filters.start_date,
            id: 'start_date',
            // label: 'Fecha inicio',
          },
          to: {
            value: pagePagination.filters.end_date,
            id: 'end_date',
            // label: 'Fecha fin',
          },
          changeFilterDateRange: handleFiltersDateRange,
        }}
        filterChoosen={[
          {
            id: 'job_position_id',
            name: 'Puesto de Trabajo',
            isClearable: true,
            isSearchable: true,
            options: options.jobPositions,
            value: pagePagination.filters.job_position_id,
            placeholder: 'Selecciona un puesto de trabajo',
            onChange: (e) => handleFilters(e, 'job_position_id'),
          },
          {
            id: 'schedule_group_id',
            label: 'Grupo de Horario',
            options: options.scheduleGroups,
            value: pagePagination.filters.schedule_group_id,
            placeholder: 'Selecciona un grupo de horario',
            isClearable: true,
            isSearchable: true,
            onChange: (e) => handleFilters(e, 'schedule_group_id'),
          },
        ]}
      />
    </>
  )
}

export default Employees
